import { render, staticRenderFns } from "./Renewal_UploadDoc.vue?vue&type=template&id=396550fb&scoped=true&"
import script from "./Renewal_UploadDoc.vue?vue&type=script&lang=js&"
export * from "./Renewal_UploadDoc.vue?vue&type=script&lang=js&"
import style0 from "./Renewal_UploadDoc.vue?vue&type=style&index=0&id=396550fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396550fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
